import { FileItemProps } from '@components/Core/Folders/FileItem/FileItem.component';
import Button from '@mui/material/Button';
import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';


export type RemoveFileDialogProps = {
  open: boolean;
  file: FileItemProps;
  handleClose: () => void;
  handleSubmit: (file: FileItemProps) => void;
}

const RemoveFileDialog = ({
  open,
  file,
  handleClose,
  handleSubmit
}: RemoveFileDialogProps) => {
  const { t } = useTranslation();

  const onSubmitClicked = () => {
    handleSubmit(file);
  };

  const onCloseClicked = () => {
    handleClose();
  };
  
  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="removeFileDialog">
      <DialogTitle>{ t('commons.delete_file') }</DialogTitle>
      <DialogContent>
        <DialogContentText>
          { t('folders.are_you_sure_remove_file', { file_name: file.name, file_type: file.type ?? 'file' })}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCloseClicked}>{ t('commons.cancel') }</Button>
        <Button onClick={onSubmitClicked} color="error">{ t('commons.delete') }</Button>
      </DialogActions>
    </Dialog>
  )
}

export default RemoveFileDialog;
